module.exports = __webpack_public_path__ + "img/gf5sat.de9dc477.png";